export const EnvConfig = {
  apiUrl: import.meta.env.VITE_API_URL ?? 'http://localhost:4000',
  env: import.meta.env.VITE_ENV ?? 'development',
};
